import React from 'react'
import classNames from 'classnames'

import { useGetTeamName } from '../hooks'
import {
  getArrayPairs,
  getArrayFours,
  getScore,
  getClassScoreNew,
  createPlaceholderDataMobile,
} from '../utils'

import styles from './styles.module.scss'
import s from '../styles.module.scss'

export const LowerRound = ({
  data,
  tournamentMember,
  nextMatchId,
  nextLoserMatchId,
  setMatchId,
  setMatchItem,
  setOpenBracketModal,
  openBracketModal,
  winnerMatchRef,
  loserMatchRef,
}) => {
  const getTeamName = useGetTeamName(tournamentMember)

  const getClassRow = (selectRow, selectRowIndex) => {
    if (!selectRow[selectRowIndex - 1]) {
      return styles.rowCenter
    }

    if (
      selectRowIndex &&
      selectRow[selectRowIndex - 1]?.rows?.length ===
        selectRow[selectRowIndex]?.rows?.length * 2
    ) {
      return styles.roundRow
    }

    if (selectRowIndex && selectRow[selectRowIndex - 1]?.rows?.length / 2 > 3) {
      return styles.rowCenter
    }

    return styles.rowCenter
  }

  return (
    <div className={styles.lowerContainer}>
      {data?.cols?.map((item, indexCols) => (
        <React.Fragment key={`cols-fragment-${item.roundName}-${indexCols}`}>
          <div
            key={`${item.roundName}-${indexCols}`}
            className={styles.roundWrapper}
          >
            <div className={styles.roundTitle}>{item?.roundName}</div>
            <div className={getClassRow(data?.cols, indexCols)}>
              {getArrayFours(createPlaceholderDataMobile(item))?.map(
                (tournament, indexTournament) => (
                  <div
                    className={classNames('teamsBlockBordersAndBg', {
                      [styles.teamsBlock]: item?.rows.length > 2,
                      [styles.teamsBlockOne]: item?.rows.length <= 2,
                      [styles.teamsBlockWithGroup]: indexCols % 2 === 0,
                    })}
                    key={`item-teams-${indexTournament}`}
                  >
                    {getArrayPairs(tournament)?.map((el, indexEl) => (
                      <div
                        onClick={() =>
                          el[0]?.matchId && setMatchId(setMatchItem(el[0]))
                        }
                        key={`el-index-${indexEl}`}
                        className={classNames(
                          'teamBlockBg',
                          'teamBlockBgLowerRound',
                          el.length > 1 ? styles.teamBlock : styles.teamBlockOne
                        )}
                      >
                        <div className={styles.borderArrow} />
                        {el?.map((block, iBlock) => (
                          <div key={`pairs-item-${block?.id}-${iBlock}`}>
                            <div className={s.matchNumber}>{block?.id}</div>
                            <div
                              ref={
                                nextMatchId === el[0]?.matchId
                                  ? winnerMatchRef
                                  : nextLoserMatchId === el[0]?.matchId
                                    ? loserMatchRef
                                    : null
                              }
                              style={
                                nextMatchId === el[0]?.matchId
                                  ? {
                                      backgroundColor: '#755f33',
                                    }
                                  : nextLoserMatchId === el[0]?.matchId
                                    ? {
                                        backgroundColor: '#755f33',
                                      }
                                    : {}
                              }
                              className={classNames(
                                'playerInfoBgAndBorder',
                                s.player
                              )}
                              onClick={() =>
                                setOpenBracketModal(!openBracketModal)
                              }
                            >
                              <span className={s.playerTitle}>
                                {getTeamName(block)}
                              </span>
                              <div
                                className={classNames(
                                  s.playerPont,
                                  getClassScoreNew(
                                    el,
                                    block,
                                    s.playerPont_orange
                                  )
                                )}
                              >
                                {getScore(block)}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                )
              )}
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  )
}

export default LowerRound
